import type { ReactNode } from "react";

import MobileHeader from "./MobileHeader";
import { MobileContent } from "./MobileContent";
import { MobileBackButton } from "../misc/MobileBackButton";

// LDF: Rahmen für Seiten in der Handy-Ansicht – Kopfzeile mit Titel (optional Zurück) und scrollbarer Inhalt.
export const MobilePage = ({
  title,
  back,
  actions,
  children,
}: {
  title: ReactNode;
  back?: string;
  actions?: ReactNode;
  children: ReactNode;
}) => (
  <>
    <MobileHeader>
      <div className="flex min-w-0 items-center gap-1">
        {back && <MobileBackButton to={back} />}
        <h1 className="truncate text-xl font-semibold">{title}</h1>
      </div>
      {actions}
    </MobileHeader>
    <MobileContent>{children}</MobileContent>
  </>
);

// Desktop-Seiten (Karte mit eigener Überschrift) auf dem Handy ohne doppelten Rand anzeigen
export const MobileWrapped = ({ title, children }: { title: string; children: ReactNode }) => (
  <MobilePage title={title}>
    <div className="-mx-4 [&_[data-slot=card]]:rounded-none [&_[data-slot=card]]:border-x-0 [&_[data-slot=card]]:shadow-none [&_h1]:hidden">
      {children}
    </div>
  </MobilePage>
);
